import React from "react";
import { Jumbotron, Container, Row, Col, Image } from "react-bootstrap";
import styled, { keyframes } from "styled-components";
import wallpaper1 from "../img/wallpaper1.webp";
import personal_photo from "../img/personal_photo.webp";

export default () => {
  return (
    <Styles>
      <Jumbotron fluid className="jumbotron vertical-center">
        <Container>
          <Row>
            <Col sm={12} md={6} className="center-align">
              <Image
                src={personal_photo}
                type="image/webp"
                fluid
                className="personal-img animate__bounce"
              />
            </Col>
            <Col sm={12} md={6} className="vertical-center text">
              <div className="intro">
                <h1>Hello, I'm Ivy</h1>
                <h4>Data Science | Web Development</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </Jumbotron>
    </Styles>
  );
};

//styling
const fadeIn = keyframes`
0% {
    opacity: 0;
  }
100% {
    opacity: 1;
  }

`;
const Styles = styled.div`
  .jumbotron {
    background-image: url(${wallpaper1});
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 64px 0px 0px 0px;
    min-height: 100vh;
  }
  .vertical-center {
    display: flex;
    align-items: center;
  }
  .center-align {
    text-align: center;
  }
  .personal-img {
    width: 65%;
    animation: 3s ${fadeIn} ease-out;
  }
  .intro {
    animation: 4s ${fadeIn} ease-out;
  }
  .text {
    color: white;
  }
  h4 {
    margin-top: 3%;
  }

  @media (min-width: 2200px) {
    .personal-img {
      width: 80%;
    }
    h1 {
      font-size: 450%;
    }
    h4 {
      font-size: 220%;
    }
  }

  @media (max-width: 2000px) {
    .personal-img {
      width: 85%;
    }
    h1 {
      font-size: 420%;
    }
    h4 {
      font-size: 180%;
    }
  }

  @media (max-width: 1536px) {
    .personal-img {
      width: 65%;
    }
    h1 {
      font-size: 320%;
    }
    h4 {
      font-size: 150%;
    }
  }

  @media (max-width: 1024px) {
    .personal-img {
      width: 100%;
    }
    h1 {
      font-size: 350%;
    }
    h4 {
      font-size: 150%;
    }
  }

  @media (max-width: 768px) {
    h4 {
      font-size: 120%;
    }
  }

  @media (max-width: 736px) {
    .personal-img {
      width: 40%;
    }
    .text {
      display: flex;
      align-items: center;
      padding-top: 10px;
      justify-content: center;
    }
    h1 {
      font-size: 190%;
    }
    h4 {
      font-size: 100%;
    }
  }
  @media (max-width: 576px) {
    .personal-img {
      width: 65%;
    }
  }
`;
